// GSAP is loaded via CDN in theme.liquid
// Using global gsap, ScrollTrigger, SplitText, and MorphSVGPlugin

// Simple DOM ready function
const domReady = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
};

// Register GSAP plugins when GSAP is available
const registerGSAPPlugins = () => {
  if (typeof gsap !== 'undefined') {
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }
  }
};

/**
 * Check if user prefers reduced motion
 */
const prefersReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

/**
 * Check if current screen size is desktop (992px and above)
 */
const isDesktop = () => {
  return window.innerWidth >= 992;
};

/**
 * Initialize parallax effect for center column cards
 */
const initTileParallax = () => {
  // Skip if user prefers reduced motion or not on desktop
  if (prefersReducedMotion() || !isDesktop()) return;

  const container = document.querySelector('.grid-flex');
  if (!container) return;

  const centerCards = container.querySelectorAll('.grid__item:nth-of-type(3n-1)');
  if (centerCards.length === 0) return;

  // Animate center column cards to move up 50px as user scrolls
  // Cards start at 80px (from CSS) and move up to -100px
  gsap.fromTo(centerCards, {
    y: 80 // Start at CSS offset position
  }, {
    y: -100, // End at -100px
    ease: 'none',
    scrollTrigger: {
      trigger: container,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 2
    }
  });
};

/**
 * Helper function to add event listener that fires only once
 */
const once = (el, event, fn, opts) => {
  const onceFn = function (e) {
    el.removeEventListener(event, onceFn);
    fn.apply(this, arguments);
  };
  el.addEventListener(event, onceFn, opts);
  return onceFn;
};

/**
 * Cleanup and reinitialize animations on resize
 */
const handleResize = () => {
  // Only reinitialize hover animations (heading animations are one-time)
  // initHoverAnimations();
  // Refresh ScrollTrigger to recalculate positions after resize
  ScrollTrigger.refresh();
};

/**
 * Animations entrypoint
 */
domReady(() => {
  // Register GSAP plugins first
  registerGSAPPlugins();
  
  // Wait for GSAP to be fully loaded
  const waitForGSAP = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(waitForGSAP, 50);
      return;
    }
    
    // Wait for window load to ensure all images/assets are fully loaded
    // This ensures ScrollTrigger can calculate correct dimensions
    const initAnimations = () => {

      // Initialize tile parallax effect for center column cards
      initTileParallax();

      // Refresh ScrollTrigger after all animations are initialized
      // This ensures all trigger positions are calculated correctly
      ScrollTrigger.refresh();
    };

    if (document.readyState === 'complete') {
      // If already loaded, initialize after a brief delay
      setTimeout(initAnimations, 100);
    } else {
      window.addEventListener('load', () => {
        setTimeout(initAnimations, 100);
      });
    }

    // Add resize listener to handle screen size changes
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 250); // Debounce resize events
    });
  };
  
  waitForGSAP();
});

// Hot module replacement removed for Shopify theme compatibility

// mega menu
// Reset checkboxes on pageshow event (fires when navigating back/forward with bfcache)
// This handles cases where browser restores checkbox state from bfcache
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    const menuCheckboxes = document.querySelectorAll('.mega-menu input[type="checkbox"]');
    menuCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Clean up related classes
    const headerContainer = document.querySelector('.header-container');
    if (headerContainer) {
      headerContainer.classList.remove('sub-menu-open');
    }
  }
});

// Function to calculate and set announcement banner height
function setAnnouncementBannerHeight() {
  const announcementBanner = document.querySelector('.announcement-banner');
  if (announcementBanner) {
    const height = announcementBanner.offsetHeight;
    document.documentElement.style.setProperty('--announcement-banner-height', (height - 2) + 'px');
  } else {
    // If no announcement banner, set to 0
    document.documentElement.style.setProperty('--announcement-banner-height', '0px');
  }
}

// Create radio-like behavior for checkboxes but allow unchecking
document.addEventListener('DOMContentLoaded', function() {
  // Get all menu checkboxes
  const menuCheckboxes = document.querySelectorAll('.mega-menu input[type="checkbox"]');
  
  // Reset checkboxes on page load (handles first visits, refreshes, direct URL access)
  menuCheckboxes.forEach(checkbox => {
    checkbox.checked = false;
  });
  
  // Set initial announcement banner height
  setAnnouncementBannerHeight();
  
  // Update height on window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(setAnnouncementBannerHeight, 150);
  });
  const hamburgerCheckbox = document.querySelector('.mega-menu #mega-menu-toggle');
  const submenuCheckboxes = Array.from(menuCheckboxes).filter(cb => cb.id.startsWith('submenu-'));

  // Add accordion behavior - only one top-level menu open at a time
  submenuCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        // Only close other top-level menus (those without hyphens in their ID after "submenu-")
        const isTopLevel = !this.id.includes('-', 8);

        if (isTopLevel) {
          // Close all other top-level submenus
          submenuCheckboxes.forEach(otherCheckbox => {
            const otherIsTopLevel = !otherCheckbox.id.includes('-', 8);
            if (otherCheckbox !== this && otherIsTopLevel) {
              otherCheckbox.checked = false;
            }
          });
        }
      }

      // Check if any top-level submenu is checked
      const anyChecked = Array.from(submenuCheckboxes).some(cb => {
        const isTopLevel = !cb.id.includes('-', 8);
        return cb.checked && isTopLevel;
      });

      if (anyChecked) {
        document.querySelector('.header-container').classList.add('sub-menu-open');
      } else {
        document.querySelector('.header-container').classList.remove('sub-menu-open');
      }
      
      // Add no-animation class to submenus if any top-level submenu is checked
      const subMenus = document.querySelectorAll('.mega-menu__sub-menu');
      if (subMenus) {
        
        if (anyChecked) {
          subMenus.forEach(menu => {
            setTimeout(() => {
              menu.classList.add('no-animation');
            }, 100);
          });
        } else {
          subMenus.forEach(menu => {
            menu.classList.remove('no-animation');
          });
        }
      }
             
    });
  });
  
  // Handle hamburger menu closing - uncheck all submenus
  if (hamburgerCheckbox) {
    hamburgerCheckbox.addEventListener('change', function() {
      console.log('hamburgerCheckbox', this.checked);
      const appElement = document.getElementById('app');
      
      if (this.checked) {
        // When hamburger opens, add overflow hidden to #app (only on mobile/tablet < 992px)
        if (appElement && window.innerWidth < 992) {
          appElement.style.overflow = 'hidden';
          appElement.style.height = '100vh';
        }
      } else {
        // When hamburger closes, remove overflow hidden and uncheck all submenu checkboxes
        if (appElement) {
          appElement.style.overflow = '';
          appElement.style.height = '';
        }
        submenuCheckboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
      }
    });
  }

  // Handle back button clicks to close child menus
  const backButtons = document.querySelectorAll('.mega-menu__back-btn');
  backButtons.forEach(backButton => {
    backButton.addEventListener('click', function() {
      // Find the parent sub-menu of this back button
      const parentSubMenu = this.closest('.mega-menu__sub-menu');
      if (parentSubMenu) {
        // Find all child menu checkboxes within this sub-menu and uncheck them
        const childMenuCheckboxes = parentSubMenu.querySelectorAll('input[type="checkbox"][id*="-"][id^="submenu-"]');
        childMenuCheckboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
      }
    });
  });

  // Uncheck all checkboxes when a link is clicked in the mega-menu
  // This ensures checkboxes are already unchecked in browser memory before navigation
  const megaMenu = document.querySelector('.mega-menu');
  if (megaMenu) {
    megaMenu.addEventListener('click', function(event) {
      const link = event.target.closest('a');
      if (link && link.href) {
        // Uncheck all checkboxes before navigation
        menuCheckboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
        
        // Remove header class
        const headerContainer = document.querySelector('.header-container');
        if (headerContainer) {
          headerContainer.classList.remove('sub-menu-open');
        }
      }
    });
  }

  // Close all menus when clicking outside
  document.addEventListener('click', function(event) {
    // Check if any menu checkbox is checked
    const hasOpenMenu = Array.from(menuCheckboxes).some(cb => cb.checked);
    
    // If there's an open menu and click is outside the mega-menu container
    if (hasOpenMenu && !event.target.closest('.mega-menu')) {
      // Uncheck all checkboxes to close everything
      menuCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      
      // Remove header class
      const headerContainer = document.querySelector('.header-container');
      if (headerContainer) {
        headerContainer.classList.remove('sub-menu-open');
      }
    }
  });
});
